// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__NjMd5","footerWrapper":"footer_footerWrapper__jPaYu"};